import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStyledButton } from 'types/ui/button.interface'

export const StyledButton = styled.button<IStyledButton>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${tokens.space.xs};
  height: ${({ $size }) => ($size === 'sm' ? '2rem' : '2.5rem')};
  padding: 0 ${({ $size }) => ($size === 'sm' ? tokens.space.sm : tokens.space.md)};
  border: 1px solid transparent;
  border-radius: ${tokens.radius.control};
  font-size: ${({ $size }) => ($size === 'sm' ? tokens.font.label : tokens.font.body)};
  font-weight: 500;
  cursor: pointer;
  transition: filter ${tokens.motion.duration} ${tokens.motion.ease},
    transform ${tokens.motion.duration} ${tokens.motion.ease};

  ${({ $variant }) =>
    (!$variant || $variant === 'primary') &&
    `background: ${tokens.accent.gradient}; color: ${tokens.accent.ink}; box-shadow: ${tokens.accent.glow};`}
  ${({ $variant }) =>
    $variant === 'secondary' &&
    `background: ${tokens.surface.glass}; color: ${tokens.text.primary}; border-color: ${tokens.border.hairline};`}
  ${({ $variant }) =>
    $variant === 'black' && `background: transparent; color: ${tokens.text.secondary};`}
  ${({ $variant }) =>
    $variant === 'danger' &&
    `background: ${tokens.status.danger.bg}; color: ${tokens.status.danger.fg}; border-color: ${tokens.status.danger.fg};`}
  ${({ $variant }) =>
    $variant === 'success' &&
    `background: ${tokens.status.success.bg}; color: ${tokens.status.success.fg}; border-color: ${tokens.status.success.fg};`}

  &:hover {
    filter: brightness(108%);
  }
  &:active {
    transform: translateY(1px);
  }
  &:focus-visible {
    outline: 2px solid ${tokens.accent.base};
    outline-offset: 2px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
